/* ============================================================
   text-and-image-cascade.js
   Cascading reveal for <ul><li> items inside
   .text-and-image__container .text-and-image__block-item
   ============================================================ */

(function () {
  'use strict';

  // Respect users who prefer reduced motion — reveal immediately, no animation.
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // IntersectionObserver fallback — if unsupported, just show everything.
  if (!('IntersectionObserver' in window)) {
    document
      .querySelectorAll('.text-and-image__container .text-and-image__block-item ul li')
      .forEach((li) => li.classList.add('is-loaded'));
    return;
  }

  const STAGGER_MS = 100; // delay between each <li> within the same <ul>

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const li = entry.target;

        if (prefersReducedMotion) {
          li.classList.add('is-loaded');
        } else {
          // Stagger via the element's own data-index, set at init time.
          const index = parseInt(li.dataset.cascadeIndex, 10) || 0;
          li.style.transitionDelay = `${index * STAGGER_MS}ms`;
          // Next frame ensures the transition picks up cleanly.
          requestAnimationFrame(() => li.classList.add('is-loaded'));
        }

        obs.unobserve(li); // reveal once, then stop observing
      });
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px', // trigger slightly before fully in view
      threshold: 0.15,
    }
  );

  function init() {
    const blocks = document.querySelectorAll(
      '.text-and-image__container .text-and-image__block-item'
    );

    blocks.forEach((block) => {
      // Index is per-<ul> so each list staggers independently.
      block.querySelectorAll('ul').forEach((ul) => {
        ul.querySelectorAll(':scope > li').forEach((li, i) => {
          li.dataset.cascadeIndex = i;
          observer.observe(li);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();